import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import config from '../config';
import { LinkItsmeAccountResponse } from "../models/link-itsme-account-response.model";
import { ResponseBroker } from "../models/response-broker.model";
import AuthenticationService from "./AuthenticationService";

const injectToken = (axiosRequestConfig: AxiosRequestConfig): AxiosRequestConfig => {
    const token = new AuthenticationService().getAuthToken();

    if (token != null) {
        // eslint-disable-next-line no-param-reassign
        axiosRequestConfig.headers.Authorization = token;
    }

    return axiosRequestConfig;
};

export default class OnboardingApi {
    private _http: AxiosInstance;

    constructor() {
        this._http = axios.create({
            baseURL: config.API_BASE_URL,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json; charset=utf-8",
                "Access-Control-Allow-Credentials": true,
                "X-Requested-With": "XMLHttpRequest",
            },
            withCredentials: true,
        });

        this._http.interceptors.request.use(injectToken, (error) => Promise.reject(error));
    }

    checkIfAccountIsLinked(): Promise<ResponseBroker> {
        return this._http.get<ResponseBroker>("/onboarding").then(
            (response) => {
                return response.data;
            },
            (error) => {
                throw error;
            },
        );
    }

    unlinkAccount(): Promise<boolean> {
        return this._http.post<boolean>("/onboarding/unlink").then(
            (response) => {
                return response.status === 200;
            },
            (error) => {
                throw error;
            },
        );
    }

    linkAccount(state: string): Promise<LinkItsmeAccountResponse> {
        const data = { state };
        return this._http.post<LinkItsmeAccountResponse>("/onboarding/link", data).then(
            (response) => {
                return response.data;
            },
            (error) => {
                throw error;
            },
        );
    }
}
